'use strict';

angular.module('mean.builders').controller('BuilderAddBidderController', ['$scope', 'Global', 'Bids', '$q', 'Users', 'MeanUser', 'toaster', 'GeneralTasks', 'Subtasks', 'Materials', 'Units', 'Equipments', '$location', 'NotifyService', 'Builders', '$filter', 'Contractors', 'daysDifferenceService', 'userService', 'bidQueryService', 'contractorQueryService', 'contactService', 'builderService', 'bidService', 'TradeBids', 'tradeCodeService', 'BidWizardEdit', 'bidPlanCodeService',
  function($scope, Global, Bids, $q, Users, MeanUser, toaster, GeneralTasks, Subtasks, Materials, Units, Equipments, $location, NotifyService, Builders, $filter, Contractors, daysDifferenceService, userService, bidQueryService, contractorQueryService, contactService, builderService, bidService, TradeBids, tradeCodeService, BidWizardEdit, bidPlanCodeService) {
    $scope.global = Global;

    $scope.tasks = [];
    $scope.subtasks = [];
    $scope.trades = tradeCodeService.getArray();
    $scope.selectedTrade = [];
    $scope.trade = [];
    $scope.bid_menu = [];
    $scope.bids = [];
    //$scope.new_bids = [];
    $scope.plan_list = [];
    $scope.original_bidders = [];
    //$scope.saved_bid_trades = [];
    $scope.new_bid_trades = [];
    $scope.available_trades = []; //list of available users
    $scope.trades_to_add = []; //list of tradeBids

    $scope.add_bidder = true;

    $scope.user = MeanUser.user;
    daysDifferenceService.setHolidaysArray($scope.user.username);

    $scope.getContacts = function() {
        //i need to get trades to populated step 4 but they need to 
        //be based on the contacts and should be company names.
        userService.getMainAccountId($scope.user.username).then(function(result) {
            contactService.getMyContacts(result).then(function(contacts) {
                if(!contacts) {
                    toaster.pop('error', 'No Contacts', 'You must have contacts in the system!');
                    return;
                }
                $scope.trade_users = contacts.trades;
                $scope.onSelect();
            });
        });
    };

    /**
     * @description determine if an array contains one or more items from another array.
     * @param {array} haystack the array to search.
     * @param {array} arr the array providing items to check for in the haystack.
     * @return {boolean} true|false if haystack contains at least one item from arr.
     */
    var findOne = function (haystack, arr) {
        return arr.some(function (v) {
            return haystack.indexOf(v) >= 0;
        });
    };

    // $scope.inOriginalList = function(item) {
    //     if ($scope.original_bidders.indexOf(item) > -1) {
    //         return true;
    //     }

    //     return false;
    // };

    //$scope.getContacts();

    $scope.bid = {};

    $scope.is_admin = userService.isAdmin($scope.user);

    if(!$scope.is_admin) {
        alert('You do not have permissions to view this page.  Contact Admin');
        return;
    }

    $scope.tradeInList = function(item) {
        if(!$scope.original_bidders) return false;

        var inlist = $filter('filter')($scope.original_bidders, {'username': item.username}, true);
        return (inlist.length)? false:true;
    };

    $scope.inList = function(item) {
        if(!$scope.available_trades) return false;

        var inlist = $filter('filter')($scope.available_trades, {'trade': item.name}, true);
        return inlist.length;
    };

    // $scope.setTrades = function() {
    //     $scope.selectedTrade = $scope.bid.bidding_trades;
    // };

    userService.getMainAccountId($scope.user.username).then(function(result) {
        Builders.query({'builder': result}, function(builders) {
            $scope.builder = builders[0];
        });
    });

    $scope.minDate = new Date();

    $scope.dateOptions = {
        dateDisabled: disabled,
        formatYear: 'yy',
        startingDay: 0,
        minDate: new Date(),
        showWeeks: false
    };

    $scope.open = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.opened = true;
    };

    // All data will be store in this object
    $scope.suppliers = [];
    $scope.equipment_suppliers = [];

    $scope.editId = 4;

    function disabled(data) {
        return daysDifferenceService.disabled(data.date, data.mode);
    };

    $scope.submitBid = function(selected) {
        //if($scope.processForm(selected) === -1) return;

        if(!$scope.bid.bid_date_requested) {
            alert('Return Date not set');
            return;
        }

        var promises = [];

        $scope.trades_to_add.forEach(function(trade) {
            var deferred = $q.defer();
            
            trade.date_requested = new Date($scope.bid.bid_date_requested);
            trade.date_received = new Date();
            var tcode = tradeCodeService.getCode(trade.trade);
            var bidType = $scope.bid.isCustom || false;
            var mainAccount = $scope.bid.userId || '';
            Subtasks.query({
                'subtask_trade': tcode,
                'type': 'syncSubtask',
                'projectType':$scope.bid.projectType,
                'geoLocation': $scope.bid.geoLocation,
                'isCustom': bidType,
                'userId': mainAccount
            }, function(subtasks) {
                trade.task_list = [];
                bidService.attachTaskList(trade, subtasks, $scope.bid.projectType, $scope.bid.geoLocation, tcode, bidType, mainAccount).then(function(results) {
                    deferred.resolve(results);
                });
            });

            promises.push(deferred.promise);
        });

        $q.all(promises).then(function(results) {
            var new_trade_promises = [];

            results.forEach(function(result) {
                var second_defer = $q.defer();
                result.$update(function(success) {
                    second_defer.resolve(success);
                });

                new_trade_promises.push(second_defer.promise);
            });

            $q.all(new_trade_promises).then(function(updated_bids) {
                for(var i=0; i<updated_bids.length; i++) {
                    $scope.bid.bidding_trades.push(updated_bids[i]);
                }
                
                $scope.bid.bid_status = 'submitted';
                $scope.bid.$update(function(results) {
                    for(var j=0; j<updated_bids.length; j=j+1) {
                        NotifyService.addNotification(updated_bids[j].username, 'toast-info', 'New Bid', 'There is a new bid request for you to fill out and return', 'No');
                    }
                    $scope.$broadcast('notificationAdded');

                    if(builderService.isBuilder($scope.user.username))
                      $location.path('builder/bids');
                }, function(error) {
                    toaster.pop('error', 'Bid Update', 'Could not update the database');
                    return;
                });
            })
        });
    };

    $scope.onSelect = function(){
        if(!$scope.bid_name || !$scope.bid_name._id) return;

        $scope.new_bid_trades = [];
        $scope.selectedTrade = [];
        $scope.trades = tradeCodeService.getArray();
        console.log('in the onSelect function');

        bidQueryService.getById($scope.bid_name._id).then(function(bid) {
            $scope.bid = bid[0];

            // if($scope.bid.project_plan.single.length)
            //   $scope.bid.project_plan.single = bidPlanCodeService.getPlans($scope.bid.project_plan);

            $scope.project_manager = $scope.bid.project_manager;

            if(!$scope.bid.bid_date_requested) $scope.bid.bid_date_requested = new Date();

            $scope.division = $scope.bid.division;
            $scope.bid.bid_date_requested = new Date($scope.bid.bid_date_requested);
            //$scope.saved_bid_trades = $scope.bid.bidding_trades;

            TradeBids.query({'bid_id': $scope.bid._id}, function(trades) {
                //make sure that all of our current trade_users
                //have a TradeBid associated with this bid

                for(var i=0; i<trades.length; i++) {
                    var inlist = $filter('filter')($scope.original_bidders, {
                        'username': trades[i].username }, true);

                    if(inlist.length === 0) {
                        $scope.new_bid_trades.push(trades[i]);
                    }
                }

                $scope.trade_users.forEach(function(user) {
                    var inlist = $filter('filter')(trades, {
                        'username': user.username}, true);

                    if(inlist.length === 0) {
                        var saved = new TradeBids({
                            trade: user.trade[0],
                            bid_id: $scope.bid._id,
                            name: user.name,
                            username: user.username,
                            email: user.email,
                            phone: user.phone
                        });

                        saved.$save(function(returned) {
                            $scope.new_bid_trades.push(returned);
                        }, function(error) {
                            toaster.pop('error', 'Saving Trade Bids', 'Problem with saving the current bid trade ' + returned.name);
                        });
                    }
                });
            });
        });
    };

    $scope.bid = BidWizardEdit.get();

    if($scope.bid && $scope.bid._id) {
        console.log('got the bid');
        //$scope.new_bids.push($scope.bid);
        $scope.bid_name = {
            _id: $scope.bid._id,
            bid_name: $scope.bid.bid_name,
            bid_status: $scope.bid.bid_status
        }

        $scope.original_bidders = angular.copy($scope.bid.bidding_trades);

        $scope.getContacts();
    } else {
        $location.path('builder/bids');
    }

    $scope.processForm = function(selected) {
        console.log($scope.available_trades);
        // if(!$scope.bid || !$scope.bid._id) {
        //     toaster.pop({
        //         type: 'error',
        //         title: 'Bid Selection',
        //         body: 'Please Select a Bid!',
        //         showCloseButton: true
        //     });

        //     return -1;
        // }

        // $scope.bid.project_manager = $scope.project_manager;

        // $scope.bid.$update(function(results) {
        //     results.bid_date_requested = new Date(results.bid_date_requested);
        //     toaster.pop({
        //         type: 'success',
        //         title: 'Bid Update',
        //         body: 'Current bid ' + $scope.bid.bid_name + ' updated.'
        //     });
        // }, function(error) {
        //     toaster.pop({
        //         type: 'error',
        //         title: 'Bid Update',
        //         body: 'Current bid ' + $scope.bid.bid_name + ' not update.'
        //     });
        //     return;
        // });
    };

    $scope.setEditId =  function(pid) {
       $scope.editId = pid;
    };

    $scope.toggleTrade = function(item) {
        console.log('in the toggleTrade function');
        // var inlist = $filter('filter')($scope.available_trades, {'trade': item.name}, true);
        if(item.on) {
            var trades = $filter('filter')($scope.trade_users, {'trade': item.name}, true)
            for(var i=0; i<trades.length; i++) {
                if($scope.tradeInList(trades[i]))
                  $scope.available_trades.push(trades[i])
            }
        } else {
            for(var i=$scope.available_trades.length-1; i>=0; i--) {
                if($scope.available_trades[i].trade[0] === item.name) {
                    var assoc_item = $filter('filter')($scope.trades_to_add, {
                        'username': $scope.available_trades[i].username}, true);
                    var idx = $scope.trades_to_add.indexOf(assoc_item[0]);
                    $scope.trades_to_add.splice(idx, 1);
                    $scope.available_trades.splice(i, 1);
                }
            }
        }

        //$scope.bid.$update();
    };

    $scope.updateTradeUsers = function(selectedTrade) {
        console.log('in the updateTradeUsers function');
        // selectedTrade will be an array of currently
        // selected trades for one trade category
        // as we get a selectedTrade we need to update
        // the trades_to_add list. $scope.saved_bid_trades

        // first just remove all of this trade
        for(var i=$scope.trades_to_add.length-1; i>=0; i--) {
            if($scope.trades_to_add[i].trade === selectedTrade[0].trade[0])
              $scope.trades_to_add.splice(i, 1);
        }

        //now get TradeBids for this trade category
        var trades = $filter('filter')($scope.new_bid_trades, {
            'trade': selectedTrade[0].trade[0]}, true);

        for(var i=0; i<selectedTrade.length; i++) {
            var inlist = $filter('filter')(trades, {
                'username': selectedTrade[i].username}, true);
            if(inlist.length > 0) {
                $scope.trades_to_add.push(inlist[0]);
            }
        }

        //$scope.bid.$update();
    };

    $scope.getTradeString = function(trade) {
        return tradeCodeService.getName(trade);
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/builders/public/controllers/builderAddBidder.js